import { searchWithinStyles } from "@insite/content-library/Widgets/ProductList/ProductListSearchWithin";
import getColor from "@insite/mobius/utilities/getColor";
import AwesomeSearch from "@us/Assets/Icons/AwesomeSearch";
import { css } from "styled-components";

searchWithinStyles.wrapper = {
    css: css`
        padding: 25px 15px 10px 15px;
    `,
};

searchWithinStyles.searchTextField = {
    iconProps: {
        src: AwesomeSearch,
        color: "primary.contrast",
        css: css`
            color: white;
        `,
        size: 15,
    },
    iconClickableProps: {
        css: css`
            height: 35px;
            width: 35px;
        `,
    },
    cssOverrides: {
        formField: css`
            width: 100%;
            button {
                background-color: ${getColor("primary.main")};
                border-radius: 2px !important;
            }
            input {
                border-radius: 2px !important;
                font-family: 'Roboto', sans-serif !important;
                font-style: italic;
                font-size: 14px !important;
            }
        `,
    },
};

searchWithinStyles.titleText = {
    variant: "h6",
    fontFamily: "'Roboto', sans-serif",
    size: 15,
}